import {
  __,
  el,
  InspectorControls,
  Fragment,
  Panel,
  PanelBody,
} from '../common/variables';
import { cl } from '../common/functions';
import { editShortcode } from './edit/edit-editor-shortcode';
import { editTitle } from './edit/edit-control-title';
import { editFilters } from './edit/edit-control-filters';
import { editGeolocation } from './edit/edit-control-geolocation';
import { editDisplay } from './edit/edit-control-display';
import { editTypes } from './edit/edit-control-types';
import { editSearch } from './edit/edit-control-search';
import { editSearchLanguage } from './edit/edit-control-search_language';
import { editSearchCountry } from './edit/edit-control-search_country';

const edit = (props) => {
  const { className, isSelected, attributes, setAttributes, setMetaValue } = props;
  return el(Fragment, {},
    el(InspectorControls, {},
      el(Panel, { className: 'glanum-leaflet__block-inspector' },
        el(PanelBody, { title: `Glanum leaflet - ${__('Configuration')}`, initialOpen: true },

          /* Text Field */
          editTitle(props),
          /* Select dropdown field */
          editDisplay(props),

          /* Select toggle field */
          editGeolocation(props),
          attributes.display === 'full' ? editFilters(props) : null,

          /* Select dropdown field */
          editTypes(props),
          attributes.display === 'full' ? editSearch(props) : null,
          attributes.display === 'full' && attributes.search === 'leaflet' ? editSearchLanguage(props) : null,
          attributes.display === 'full' && attributes.search === 'leaflet' ? editSearchCountry(props) : null,
        ),
      ),
    ),
    /* Editor Shortcode field */
    editShortcode(props)
  )

}

export { edit };
